// Local storage helpers + auth state.
//
// We use localStorage + Bearer-token auth (industry-standard pattern, same
// approach Auth0/Firebase/Clerk default to for SPAs). This is an intentional
// tradeoff vs httpOnly cookies: simpler cross-origin handling for the
// preview/prod domain split, no CSRF surface, and acceptable for a free
// lead-magnet (no payment data, no PII beyond email + brand info).
// Primary defense against XSS is sanitization on render, which React handles
// automatically for all interpolated content in this codebase.

const TOKEN_KEY = "bpt_jwt";
const USER_KEY = "bpt_user";
const QUIZ_KEY = "bpt_quiz_state";
const AUDIT_KEY = "bpt_audit_state";
const NAME_KEY = "bpt_name_state";

const safeGet = (k) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : null;
  } catch (err) {
    // Storage may be disabled (private mode, quota exceeded, etc.).
    // Log so we can see it in dev tools without crashing the UI.
    if (typeof console !== "undefined") console.warn(`storage:get(${k}) failed`, err);
    return null;
  }
};

const safeSet = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch (err) {
    if (typeof console !== "undefined") console.warn(`storage:set(${k}) failed`, err);
  }
};

const safeRemove = (k) => {
  try {
    localStorage.removeItem(k);
  } catch (err) {
    if (typeof console !== "undefined") console.warn(`storage:remove(${k}) failed`, err);
  }
};

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (err) {
    if (typeof console !== "undefined") console.warn("storage:getToken failed", err);
    return null;
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (err) {
    if (typeof console !== "undefined") console.warn("storage:setToken failed", err);
  }
};

export const clearToken = () => safeRemove(TOKEN_KEY);

export const getUser = () => safeGet(USER_KEY);
export const setUser = (user) => safeSet(USER_KEY, user);
export const clearUser = () => safeRemove(USER_KEY);

export const signOut = () => { clearToken(); clearUser(); };

// Backwards-compat aliases used by older pages
export const getLead = () => getUser();
export const setLead = (u) => setUser(u);
export const clearLead = () => signOut();

export const getQuizState = () => safeGet(QUIZ_KEY);
export const setQuizState = (state) => safeSet(QUIZ_KEY, state);

export const getAuditState = () => safeGet(AUDIT_KEY);
export const setAuditState = (state) => safeSet(AUDIT_KEY, state);

export const getNameTestState = () => safeGet(NAME_KEY);
export const setNameTestState = (state) => safeSet(NAME_KEY, state);
